import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import AppService from '../../service/AppService';
import CustomPageDrawerMenu from './CustomPageDrawerMenu';
import gql from 'graphql-tag';

const CustomPageHeader = (props) => {

  let {
    headerBlock,
    selected,
  } = props;

  let [showSidebar, setShowSidebar] = useState(false);
  let [currActive, setCurrActive] = useState('');
  let [prevActive, setPrevActive] = useState('');
  let [lockObserver, setLockObserver] = useState(false);
  let fallbackSrc = AppService.staticUrl('/common/images/brands/doterai-logo.png');
  let linkList = [];

  let _clickNav = (e) => {
    let el = e.currentTarget;
    if (el.dataset.anchor !== '') {
      e.preventDefault();
      // Create a timeout of 1second to hold OBSERVER from changing the selectedIndex while scroll animation is running
      setLockObserver(true);
      setTimeout(
        function() {
          setLockObserver(false);
        }.bind(this),
        1000,
      );
      //console.log('Sidebar history', history)

      setPrevActive(currActive);
      setCurrActive(el.dataset.anchor);
    }

  };

  useEffect(() => {
    if (!lockObserver) {
      setPrevActive(currActive);
      setCurrActive('#' + selected);
    }
  }, [selected]);

  const onClickHamburger = () => {
    setShowSidebar(!showSidebar);
  };

  const onCloseSidebar = () => {
    setShowSidebar(false);
  };

  const renderMenuList = (headerMenus = [{}]) => {
    if (!Array.isArray(headerMenus)) return undefined;
    return headerMenus.map((menu, i) => {
      // to check if the url is starts with # (anchor link)
      linkList.push(menu.menuUrl);
      let dataAnchor = '';

      if (typeof menu.menuUrl === 'string' && menu.menuUrl.startsWith('#')) {
        dataAnchor = menu.menuUrl;
      }
      return (
        <li key={i} className={clsx('nav-item',
          currActive == dataAnchor ? 'active' : '',
        )}>
          <a className="fs-16 nav-link js_scroll" onClick={_clickNav} data-anchor={dataAnchor}
             href={menu.menuUrl}>{menu.menuText}</a>
        </li>
      );
    });
  };

  const onBrandLogoError = (ev) => {
    ev.target.src = fallbackSrc;
  };

  // console.log('>> headerBlock', headerBlock);

  return (
    <div>
      <CustomPageDrawerMenu key="dt-dmenu" headerBlock={headerBlock} onClose={onCloseSidebar} show={showSidebar}
                            fallbackBrandLogo={onBrandLogoError}/>
      <div id="doterai-header-placeholder"></div>
      <div className="fixed-top" id="doterai-header-wrapper">
        <div id="doterai-header" style={{ opacity: 1, visibility: 'visible' }}>
          <div className="container-fluid aw-locale-ja py-md-3 py-lg-3">
            <div className="my-4">
              <div className="doterai-header">
                <div className="d-flex flex-row align-items-center">
                  <div className="logo-container">
                    <a href="#page-wrapper" className="js_scroll" onClick={_clickNav} data-index="0">
                      <img src={headerBlock.headerLogoUrl} onError={onBrandLogoError}/>
                    </a>
                  </div>
                  <div id="doterai-menu">
                    <div onClick={onClickHamburger} id="mobile-nav"><i className="fa fa-bars"></i></div>
                    <div className="navbar-collapse d-flex hidden-sm-down">
                      <ul className="navbar-nav flex-row ml-auto">
                        {renderMenuList(headerBlock.headerMenus)}
                      </ul>
                      {false &&
                      <button className="btn btn-primary btn-lg fs-16 font-weight-sbold px-4-5" href="#">来場登録</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CustomPageHeader.fragments = {
  headerBlock: gql`
      fragment CustomPageHeader_headerBlock on CustomPageHeaderBlockCacheResponseSchemaType {
          headerType
          headerLayoutType
          headerLogoUrl
          headerMenus {
              menuText
              menuUrl
          }
      }
  `,
};

CustomPageHeader.propTypes = {
  headerBlock: PropTypes.shape({
    headerType: PropTypes.string,
    headerLayoutType: PropTypes.string,
    headerLogoUrl: PropTypes.string,
    headerMenus: PropTypes.arrayOf(PropTypes.shape({
      menuText: PropTypes.string,
      menuUrl: PropTypes.string,
    })),
  }).isRequired,
};

export default CustomPageHeader;
